import React from 'react'
import { css } from '@emotion/react'
import { Carousel } from '../base-ui'
import { ProductCard } from './'


function RelatedCarousel({ items }) {
    const carouselSettings = {
        rtl: true,
        loop: false,
        controls: true,
        // dots: true,
        preview: { sm: 1, md: 2, lg: 3, xl: 3, xxl: 4 }
        // style: dotStyle
    }

    const carouselStyle = css`
        // width: 10rem;
        // height: 20rem;
    `
    return (
        <div>
            <Carousel {...carouselSettings}>
                {items.map((item, idx) =>
                    <div key={idx} className="keen-slider__slide" css={carouselStyle}>
                        <ProductCard title={item.title} src={item.src} category={item.category} />
                    </div>
                )}
            </Carousel>
        </div>
    )
}

export default RelatedCarousel